import React from 'react';
import { View } from '@gin-betting/core';

import { AnalyticAttrs } from 'services/analytics';
import LogoTitle from '../LogoTitle';
import PrematchDate from '../PrematchDate';

import './teamsTitleColumn.scss';

interface Props {
    competitorsValid: View.CompetitorsValid;
    analytics?: Partial<AnalyticAttrs>;
    isHomeServer: boolean;
    isAwayServer: boolean;
    startTime: string;
}

const TeamsTitleColumn: React.FC<Props> = ({
    competitorsValid,
    analytics,
    isHomeServer,
    isAwayServer,
    startTime,
}) => {
    const {
        awayLogo,
        awayName,
        homeLogo,
        homeName,
        competitorType,
    } = competitorsValid;

    return (
        <div
            styleName="container"
            className="__app-TeamsTitleRow-container"
            {...analytics}
        >
            <LogoTitle
                logoUrl={homeLogo}
                name={homeName}
                competitorType={competitorType}
                isServer={isHomeServer}
            />
            <PrematchDate startTime={startTime} />
            <LogoTitle
                logoUrl={awayLogo}
                competitorType={competitorType}
                name={awayName}
                isServer={isAwayServer}
            />
        </div>
    );
};

export default TeamsTitleColumn;
